import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import DashboardCards from "../components/DashboardCards/DashboardCards";
// removed unused icon imports
import "../styles/Dashboard.css";
import LineChartComponent from "../components/LineGraphComponent/LineChartComponent";
import BarChartComponent from "../components/GraphComponent/BarChartComponent";
import TableComponent from "../components/TableComponent/TableComponent";
// FarmerMap removed (unused)
import TitleComponent from "../components/TitleComponent/TitleComponent";
import { useSelector, useDispatch } from "react-redux";
// tenant lists fetched via tenants actions when needed
import { handleUpdateUser } from "../store/actions/userActions";
import { handleGetCompanyData } from "../store/actions/adminActions";
import { ICONS } from "../constants/constants";
import { Link } from "react-router-dom";
import { handleGetTenantData,handleGetTenantFarmersData, handleGetTenantSuppliersData, handleGetTenantConsultantsData } from "../store/actions/tenantsActions";
// import EditFarmerModal from "../components/Modals/EditFarmerModal";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Loader from "../assets/images/loader.gif";

const Farmers = () => {
  const dispatch = useDispatch();
  const { adminList } = useSelector((state) => state.admin);
  const { user } = useSelector((state) => state.user);
  const { tenantFarmersData, tenantSuppliersData, tenantConsultantsData, isLoading } = useSelector((state) => state.tenants);

  const superAdminFarmers = tenantFarmersData?.data?.farmers;
 
  const superAdminSuppliers = tenantSuppliersData?.data?.suppliers;
  const superAdminConsultants = tenantConsultantsData?.data?.consultants;



  const adminId = user?.id;
  const companyId = user?.company?.id;
  const role = user?.role;
  const tenantId = role === "superadmin" ? user?.tenant?.id : null; // Save superAdminId if role is superadmin
  useEffect(() => {
    if (role === "superadmin" && tenantId) {
      // Fetch tenant data for superadmin
      dispatch(handleGetTenantData(tenantId));
      dispatch(handleGetTenantFarmersData(tenantId));
      dispatch(handleGetTenantSuppliersData(tenantId));
      dispatch(handleGetTenantConsultantsData(tenantId));
    } else if ((role === "admin" || role === "manager") && companyId) {
      // Fetch company data for admin users (company contains farmers, suppliers, consultants)
      dispatch(handleGetCompanyData(companyId));
    }
  }, [dispatch, adminId, tenantId, role, companyId]);

  // Support both admin/getadmindata and company/:id response shapes
  const companySource = adminList?.admin || adminList?.data?.company;
  const companyName = companySource?.name || companySource?.company?.name;

  // Fetch the farmer list conditionally based on the role
  const farmersListFromStore = useSelector((state) => state.farmer); // Always call useSelector
  const suppliersListFromStore = useSelector((state) => state.supplier);
  const consultantsListFromStore = useSelector((state) => state.consultant);


  const farmerList =
    role === "admin" || role === "manager"
      ? (companySource?.adminUsers ||
          companySource?.suppliers?.filter((user) => user.role === "farmer") ||
          [])
      : superAdminFarmers;

  // For manager role show only Approved users
  const visibleFarmerList =
    role === "manager"
      ? ( (companySource?.adminUsers || companySource?.suppliers || []).filter((u) => u.role === "farmer" && u.account_status === "Approved") )
      : farmerList;

      

  // Convert budgetPerAcre to a number
  const budgetPerAcre =
    parseFloat(adminList?.shiriahBudget?.[0]?.budgetPerAcre) || 0;

  let totalBudget = 0; // Initialize total budget separately

  // Calculate total budget for each farmer
  const farmersWithBudget = (farmerList || []).map((farmer) => {
    let farmerBudget = 0;

    if (farmer.farmDetails?.length > 0) {
      farmerBudget = farmer.farmDetails.reduce((sum, farm) => {
        const farmArea = parseFloat(farm.farm_area) || 0; // Convert farm_area to number safely
        return sum + farmArea * budgetPerAcre;
      }, 0);
    }

    totalBudget += farmerBudget; // Accumulate total budget separately

    return { ...farmer, farmerBudget }; // Store farmer's budget separately
  });

  // Define a function to handle account status update to "Approved"
  const approveSupplier = async (farmerId) => {
    const formData = { account_status: "Approved" };
    await handleUpdateUser(farmerId, formData, dispatch);
  };

  // Define data for BarChartComponent
  const barChartData = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [
      {
        label: "2024",
        data: [12, 19, 3, 5, 2, 3, 7],
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
      {
        label: "2023",
        data: [10, 14, 5, 2, 20, 30, 45],
        backgroundColor: "rgba(255, 159, 64, 0.6)",
      },
    ],
  };

  // Define data for LineChartComponent
  const lineChartData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"],
    datasets: [
      {
        label: "Budget",
        data: [30, 45, 28, 50, 42, 56, 40, 55, 30],
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        tension: 0.4,
      },
      {
        label: "Revenue",
        data: [20, 35, 25, 45, 35, 50, 38, 48, 25],
        borderColor: "rgba(255, 159, 64, 1)",
        backgroundColor: "rgba(255, 159, 64, 0.2)",
        tension: 0.4,
      },
      {
        label: "Farmed",
        data: [25, 40, 22, 48, 38, 52, 33, 50, 28],
        borderColor: "rgba(153, 102, 255, 1)",
        backgroundColor: "rgba(153, 102, 255, 0.2)",
        tension: 0.4,
      },
    ],
  };

  // const [showEditModal, setShowEditModal] = useState(false); // State to control edit modal visibility
  // // Handle edit icon click to show edit modal
  // const handleEditClick = () => {
  //   setShowEditModal(true); // Show the edit modal
  // };

  // PDF Downloader
  const handleDownloadPDF = (farmer) => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(18);
    doc.text("Farmer Details", 14, 20);

    // Farmer Data
    // const farmArea = farmer.farmDetails?.reduce(
    //   (sum, farm) => sum + (parseFloat(farm.farm_area) || 0),
    //   0
    // );

    const tableColumn = ["Field", "Details"];
    const tableRows = [
      ["ID", farmer?.id],
      ["Name", farmer?.name],
      ["Company", farmer?.company?.name || companyName || "N/A"],
      ["Phone", farmer?.mobile_number || "N/A"],
      ["CNIC", farmer?.cnic || "N/A"],
      // ["Farm Area", farmArea ? `${farmArea} acres` : "N/A"],
      ["Status", farmer?.account_status || "Pending"],
    ];

    // AutoTable for formatting
    doc.autoTable({
      startY: 30,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      headStyles: {
        fillColor: [0, 128, 0], // Green header background
        textColor: [255, 255, 255], // White text color
        fontStyle: "bold",
      },
    });

    // Save PDF
    doc.save(`Farmer_${farmer?.id}.pdf`);
  };
 
  const tableTitle = "Farmers";
const searchplaceholder = "Search by Farmer’s Name";
  const columns = ["Name", "Company", role !== "manager" ? "Mobile" : "", role !== "manager" ? "CNIC" : "", "Status", "Actions"];
  //console.log("Farmer List:", farmerList);
  const data = visibleFarmerList?.map((farmer) => ({
    Name: farmer?.name,
    Company: farmer?.company?.name || companyName || "N/A", // Use company name if available
    Mobile: farmer?.mobile_number || "N/A", // Replace 'N/A' with default if 'mobile' is not available
    CNIC: farmer?.cnic,
    Status: farmer?.account_status,
    farmerColor: farmer?.farmer_color,
    ...(role !== "manager" ? { Mobile: farmer?.mobile_number || "N/A" } : {}), // Replace 'N/A' with default if 'mobile' is not available
    ...(role !== "manager" ? { CNIC: farmer?.cnic } : {}),
    Actions:
      role === "manager" ? (
        <>
          <Link to={`/farmer/${farmer.id}`} state={{ farmer }} rel="noopener noreferrer">
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" style={{ opacity: 0.5, pointerEvents: "none" }} />
        </>
      ) : farmer?.account_status === "Approved" ? (
        <>
          <Link to={`/farmer/${farmer.id}`} state={{ farmer }} rel="noopener noreferrer">
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" onClick={() => handleDownloadPDF(farmer)} />
        </>
      ) : (
        <>
          <Link to={`/farmer/${farmer.id}`} state={{ farmer }} rel="noopener noreferrer">
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
        </>
      ),
  }));

  // Pass dynamically if these features should be shown
  const showSearchBar = true; // Change to false to hide search bar
  const showFilter = true; // Change to false to hide filter
  const showTabs = true; // Change to false to hide tabs (Approved/Not Approved)
  const showColors = false;

 //console.log("Admin List:", adminList?.admin?.adminUsers);
  // const getCountByApprovalStatus = (role, status) => {
  //   console.log("Admin List:", adminList?.admin?.adminUsers);
  //   console.log(`Filtering for role: ${role}, status: ${status}`);
  //   return (
  //     adminList?.admin?.adminUsers?.filter(
  //       (user) => user.role === role && user.account_status === status
  //     ).length || 0
  //   );
  // };

  const getCountByRole = (userRole) => {
    const users =
      companySource?.adminUsers ||
      companySource?.suppliers ||
      adminList?.admin?.adminUsers ||
      [];
    return users.filter((user) => user.role === userRole).length || 0;
  };

 const getCounts = () => {
//  console.log(`Getting counts for role: ${role}`);
  const { farmers, suppliers, consultants } = getUsersByRole(role);
// console.log(`Counts - Farmers: ${farmers.length}, Suppliers: ${suppliers.length}, Consultants: ${consultants.length}`);
  return {
    farmers: farmers.length,
    suppliers: suppliers.length,
    consultants: consultants.length,
  };
};


  const getUsersByRole = (role) => {
  if (role === "superadmin") {
    return {
      farmers: superAdminFarmers || [],
      suppliers: superAdminSuppliers || [],
      consultants: superAdminConsultants || [],
    };
  }
  if (role === "admin" || role === "manager") {
    const users = companySource?.adminUsers || companySource?.suppliers || adminList?.admin?.adminUsers || [];
    return {
      farmers: users.filter((u) => u.role === "farmer") || [],
      suppliers: users.filter((u) => u.role === "supplier") || [],
      consultants:
        users.filter((u) => u.role === "consultant") ||
        consultantsListFromStore?.consultantList?.data?.consultants ||
        [],
    };
  }
  return {
    farmers: farmersListFromStore?.farmersList?.data?.farmers || [],
    suppliers: suppliersListFromStore?.suppliersList?.data?.suppliers || [],
    consultants:
      consultantsListFromStore?.consultantList?.data?.consultants || [],
  };
};

const getCountByApprovalStatus = (userRole, status) => {
  console.log(`Getting count for role: ${userRole} with status: ${status}`);
  const { farmers, suppliers, consultants } = getUsersByRole(role); // role = logged-in user

  const roleMap = {
    farmer: farmers,
    supplier: suppliers,
    consultant: consultants,
  };

  const list = roleMap[userRole] || [];

  return list.filter((user) => user.account_status === status).length;
};


  const cardData = [
    ...(user?.role !== "manager"
      ? [
        {
          title: "Shariah Budget",
          value: `${totalBudget} PKR`,
          colorKey: "budget",
          imageKey: "budgetIcon",
        },
        ]
      : []),
    
    {
  title: "No of Farmers",
  value: `${
    (role === "admin" || role === "manager")
      ? getUsersByRole(role).farmers.length
      : getCounts().farmers
  }`,
  colorKey: "farmer",
  imageKey: "farmerIcon",
},
   {
  title: "Approved Farmers",
    value: `${
    (role === "admin" || role === "manager")
      ? getCountByApprovalStatus("farmer", "Approved")
      : getCountByApprovalStatus("farmer", "Approved")
  }`,
  colorKey: "supplier",
  imageKey: "activefarmerIcon",
},
    {
      title: "Not Approved Farmers",
      value: `${
    (role === "admin" || role === "manager")
      ? getCountByApprovalStatus("farmer", "NotApproved")
      : getCountByApprovalStatus("farmer", "NotApproved")
  }`,
  colorKey: "consultant",
      imageKey: "inactivefarmerIcon",
    },
  ];

  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }

  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container mb-2">
          <TitleComponent title="Dashboard" />
          <DashboardCards cardData={cardData} />
        </Col>
      </Row>
      {user?.role !== "manager" && (
        <Row className="d-flex justify-content-between two-columns">
          <Col md={5} className="component-container mb-2">
            <TitleComponent title="Productions Details" />

            <BarChartComponent data={barChartData} />
          </Col>
          <Col md={5} className="component-container right mb-2 ms-1">
            <TitleComponent title="Finance" />

            <LineChartComponent data={lineChartData} />
          </Col>
        </Row>
      )}
      <Row>
        <Col lg={12} className="component-container mb-2">
          <TableComponent
            columns={columns}
            data={data}
            title={tableTitle}
            showSearchBar={showSearchBar}
            searchplaceholder={searchplaceholder}
            showFilter={showFilter}
            showTabs={showTabs && user?.role !== "manager"}
            showColors={showColors}
          />
        </Col>
      </Row>
      {/* <EditFarmerModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        user={user}
        userType={user?.userdatarole}
      /> */}
    </Container>
  );
};

export default Farmers;
